import React from "react";

import Logo from "../../Logo/Logo";
import NavigationItems from "../NavigationItems/NavigationItems";
import "./SideDrawer.css";
import Backdrop from "../../UI/Backdrop/Backdrop";
import Aux from "../../../hoc/_Aux/_Aux";
import classNames from "classnames";

const sideDrawer = props => {
    return (
        <Aux>
            <Backdrop show={props.open} clicked={props.closed} />
            <div
                className={classNames({
                    "SideDrawer Close": !props.open,
                    "SideDrawer Open": props.open
                })}
                onClick={props.closed}
            >
                <div className="Logo">
                    <Logo />
                </div>
                <nav>
                    <NavigationItems isAuthenticated={props.isAuth} />
                </nav>
            </div>
        </Aux>
    );
};

export default sideDrawer;
